module.exports = __webpack_public_path__ + "img/Hotline-a.bfd20883.png";